export default __webpack_public_path__ + "static/media/Adobe.866afe70.png";